import api from '../../api'
import * as types from '../mutation-types'

// initial state
// shape: [{ id, quantity }]
const state = {
  customer: {}
}

// getters
const getters = {
  customer: state => state.customer
}

// actions
const actions = {
  getSchedule ({ commit }, date) {
    return new Promise((resolve, reject) => {
      api.getSchedule(date, data => {
        if (data.error) {
          reject(data)
        } else {
          resolve(data)
        }
      })
    })
  },
  getAlarm ({ commit }) {
    return new Promise((resolve, reject) => {
      api.getAlarm(data => {
        if (data.error) {
          reject(data)
        } else {
          resolve(data)
        }
      })
    })
  },
  getSteps ({ commit }) {
    return new Promise((resolve, reject) => {
      api.getSteps(data => {
        if (data.error) {
          reject(data)
        } else {
          resolve(data)
        }
      })
    })
  },
  getCustomer ({ commit }, id) {
    return new Promise((resolve, reject) => {
      api.getCustomer(id, data => {
        if (data.error) {
          reject(data)
        } else {
          // data.installer__user__first_name = data.installer.name
          commit(types.LOAD_CUSTOMER, { data })
          resolve()
        }
      })
    })
  },
  saveCustomer ({ commit, state }, data) {
    return new Promise((resolve, reject) => {
      api.saveCustomer(data, data => {
        if (data.error) {
          reject(data)
        } else {
          if (data.statusText === 'Created') {
            resolve('신규등록 완료')
          } else {
            resolve('고객정보 수정 완료')
          }
          commit(types.SAVE_CUSTOMER, { data })
        }
      })
    })
  },
  saveStep ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.saveStep(data, data => {
        if (data.error) {
          reject(data)
        } else {
          resolve(data)
        }
      })
    })
  },
  getRequired ({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.getRequired(data, data => {
        if (data.error) {
          reject(data)
        } else {
          resolve(data)
        }
      })
    })
  }
}
// mutations
const mutations = {
  [types.LOAD_CUSTOMER] (state, { data }) {
    state.customer = data
  },
  [types.SAVE_CUSTOMER] (state, { data }) {
    state.customer = data
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/solarhome.js